/*
 * 
 * @license Copyright © Fabasoft R&D GmbH, A-4020 Linz, 1995-2011.
 * 
 * All rights reserved. All hardware and software names used are registered trade names and/or registered trademarks of  
 * the respective manufacturers.
 * 
 * The user of this computer program acknowledges that the above copyright notice, which constitutes the Universal 
 * Copyright Convention, will be attached at the position in the function of the computer program which the author has 
 * deemed to sufficiently express the reservation of copyright. It is prohibited for customers, users and/or third  
 * parties to remove, modify or move this copyright notice.
 * 
 * This computer program is protected by copyright law and international treaties. Unauthorized reproduction or 
 * redistribution of this program, or any portion of it, may result in severe civil and criminal penalties.
 * 
 * The use of this software requires a valid license agreement for this software. This license agreement specifies 
 * especially permitted use through the licensing model. A license agreement must already exist prior to installing the 
 * software as the installation process of this software does not include the conclusion of a license agreement.
 */

define(["jquery"], function (jQuery) {
(function ($) {
    var methods = {
    	init: function(options) {
    		var settings = $.extend({
    			correctParagraph: true,
    			correctLists: true,
    			clearPaste: true,
    			enableFirefoxEditors: false
    		}, options);
    		
    		return this.each(function() {
    			var el = $(this);
    			el.data('settings', settings);
    			
    			el.attr('contentEditable', 'true');
    			
    			el.off('keyup.editor').on('keyup.editor', methods._removePasteMarker);
    			el.off('mouseup.editor').on('mouseup.editor', methods._removePasteMarker);
    			el.off('focus.editor').on('focus.editor', methods._focus(this));

    			settings.paste = 'paste';
    			if ($.browser.msie) {
    				settings.paste = 'beforepaste';
    			}
    			
                el.off(settings.paste).on(settings.paste, function() {
                    el.editor('wrapSelection');
                });
                
                if (settings.correctParagraph) {
                	el.on('keydown.editor', methods._correctParagraph);
                }
                
                if (settings.enableFirefoxEditors) {
                	try {
                		document.execCommand('enableInlineTableEditing', false, false);
                		document.execCommand('enableObjectResizing', false, false);
                	} catch (ex) {}
                }
                
                el.find('img').attr('contentEditable', 'false').attr('unselectable', 'on');
                
                var first = el.find(':first-child');
                if (first.length > 0) {
                	methods._setSelectionBefore(el, first.get(0));
                }
    		});
    	},
    	
    	destroy: function() {
    		return this.each(function() {
    			var el = $(this);
    			var settings = el.data('settings');
    		
    			el.attr('contentEditable', 'false');
    			el.off('.editor');
    			
    			if (settings.paste) {
    				el.off(settings.paste);
    			}
    			
    			el.removeData('settings');
    		});
    	},
    	
        selection: function() {
            var val = '';
            var sel = methods._getSelectionRange();
            
            if (sel) {
            	if (window.getSelection) {
            		val = sel.toString();
            	} else if (document.selection) {
            		val = sel.text;
            	}
            }
            
            return val;
        },
        
        saveSelection: function(el) {
        	var ancestors = methods.ancestors(el);
        	if (el && ancestors.length > 0 && ancestors[0].get(0).nodeName.toLowerCase() != 'body') {
    			methods._saveRange(el);
    			$(el).trigger('savedSelection');
        	}
        },
        
        selectNode: function(el, node, content) {
        	if (content) {
        		methods._setSelectionContent(node);
        	} else {
        		methods._setSelection(node);
        	}
        	
        	methods._saveRange(el);
			$(el).trigger('savedSelection');
        },
        
        restoreSelection: function() {
        	var settings = $(this).data('settings');
        	
        	if (settings && settings.savedRange) {
    			$(this).focus();
    			
    			if (window.getSelection) {
    				window.getSelection().removeAllRanges();
    				window.getSelection().addRange(settings.savedRange);
    				$(this).focus();
    			} else {
    				settings.savedRange.select();
    			}

        		$(this).trigger('restoredSelection');
        	}
        },
        
        hasSelection: function() {
        	var settings = $(this).data('settings');
        	if (settings && settings.savedRange != null) {
        		return true;
        	}
        	
        	return false;
        },
        
        container: function() {
        	var sel = methods._getSelectionAncestorContainer();
        	if (sel && sel.nodeType == 3) { // Node.TEXT_NODE
        		return $(sel).parent(); 
        	}
        	
        	return $(sel);
        },
        
        ancestors: function(el) {
        	var arr = [];
        	var container = methods.container();
        	
        	var node;
        	if (this.get) {
        		node = this.get(0);
        	} else if (el) {
        		node = el;
        	}
        	
        	if (node && container.length > 0) {
        		while (container.get(0) !== node && container.get(0).nodeName.toLowerCase() != 'body') {
        			arr.push(container);
        			container = container.parent();
        		}
        		
       			arr.push(container);
        	}
        	
        	return arr.reverse();
        },

        overwrite : function(node) {
            methods._overwriteWithNode(node);
        },

        wrapSelection: function() {
            var originalRange = methods._getSelectionRange();
            var content;
            
            if (originalRange.extractContents) {
                var marker = document.createElement('div');
                marker.setAttribute('class', 'paste-marker');
                
                content = originalRange.extractContents();
                if (!content || content.textContent.length < 1) {
                	var textNode = document.createTextNode('&nbsp;');
                	content.appendChild(textNode);
                }
                
                marker.appendChild(content);
                
                originalRange.insertNode(marker);
                originalRange.selectNodeContents(marker);
                
                var range = originalRange.cloneRange();
                var selection = window.getSelection();
                
                selection.removeAllRanges();
                selection.addRange(range);
            } else {
                content = originalRange.htmlText;
                
                if (!content || content.length < 1) {
                    content = '&nbsp;';
                }
                
                originalRange.pasteHTML('<div class="paste-marker">' + content + '</div>');
                originalRange.select();
                
                var range = document.body.createTextRange();
                
                range.moveToElementText($('div.paste-marker').get(0));
                range.select();
            }
    	},
    	
    	triggerStateChanged: function() {
    		methods._triggerStateChanged(this);
    	},

        normalText: function() {
			var container = methods.container();
			var nodeName = container.get(0).nodeName.toLowerCase();
			
			if ((/^h[1-5]/).test(nodeName)) {
				var corrected = $('<p/>').append(container.html());
				container.replaceWith(corrected);
				
				methods._setSelectionAfter(this, corrected.get(0));
			}
        },

        formatBlock: function(blockElement) {
            if ($.browser.msie) {
                methods._executeCommand(this, 'formatBlock', false, '<' + blockElement + '>');
            } else {
                methods._executeCommand(this, 'formatBlock', false, blockElement);
            }
        },

        isBoldPossible: function() {
            return methods._queryCommandEnabled(this, 'bold');
        },
        
        bold: function() {
            methods._executeCommand(this, 'bold');
        },
        
        isItalicPossible: function() {
        	return methods._queryCommandEnabled(this, 'italic');
        },
        
        italic: function() {
        	methods._executeCommand(this, 'italic');
        },
        
        isUnderlinePossible: function() {
        	return methods._queryCommandEnabled(this, 'underline');
        },
        
        underline: function() {
        	methods._executeCommand(this, 'underline');
        },
        
        isSubscriptPossible: function() {
        	return methods._queryCommandEnabled(this, 'subscript');
        },
        
        subscript: function() {
        	methods._executeCommand(this, 'subscript');
        },
        
        isSuperscriptPossible: function() {
        	return methods._queryCommandEnabled(this, 'superscript');
        },
        
        superscript: function() {
        	methods._executeCommand(this, 'superscript');
        },
        
        isStrikethroughPossible: function() {
        	return methods._queryCommandEnabled(this, 'strikethrough');
        },
        
        strikethrough: function() {
        	methods._executeCommand(this, 'strikethrough');
        },

        isCenterPossible: function() {
        	return methods._queryCommandEnabled(this, 'justifycenter');
        },
        
        center: function() {
        	methods._executeCommand(this, 'justifycenter');
        },
        
        isFullPossible: function() {
        	return methods._queryCommandEnabled(this, 'justifyfull');
        },
        
        full: function() {
        	methods._executeCommand(this, 'justifyfull');
        },
        
        isLeftPossible: function() {
        	return methods._queryCommandEnabled(this, 'justifyleft');
        },
        
        left: function() {
        	methods._executeCommand(this, 'justifyleft');
        },
        
        isRightPossible: function() {
        	return methods._queryCommandEnabled(this, 'justifyright');
        },
        
        right: function() {
        	methods._executeCommand(this, 'justifyRight');
        },

        isInsertHorizontalRulePossible: function() {
        	return methods._queryCommandEnabled(this, 'inserthorizontalrule');
        },
        
        insertHorizontalRule: function() {
        	methods._executeCommand(this, 'inserthorizontalrule');
        },
        
        isInsertParagraphPossible: function() {
        	return methods._queryCommandEnabled(this, 'insertparagraph');
        },
        
        insertParagraph: function() {
        	methods._executeCommand(this, 'insertparagraph');
        },
        
        istOrderedListPossible: function() {
        	return methods._queryCommandEnabled(this, 'insertorderedlist');
        },
        
        orderedList: function() {
        	methods._executeCommand(this, 'insertorderedlist');
        	methods._correctLists(this);
        },
        
        isUnorderedListPossible: function() {
        	return methods._queryCommandEnabled(this, 'insertunorderedlist');
        },
        
        unorderedList: function() {
        	methods._executeCommand(this, 'insertunorderedlist');
        	methods._correctLists(this);
        },

        isRedoPossible: function() {
        	return methods._queryCommandEnabled(this, 'redo');
        },
        
        redo: function() {
        	methods._executeCommand(this, 'redo');
        },
        
        isUndoPossible: function() {
        	return methods._queryCommandEnabled(this, 'undo');
        },
        
        undo: function() {
        	methods._executeCommand(this, 'undo');
        },
        
        isUnlinkPossible: function() {
        	return methods._queryCommandEnabled(this, 'unlink');
        },
        
        unlink: function() {
        	methods._executeCommand(this, 'unlink');
        },

        isIndentPossible: function() {
        	return methods._queryCommandEnabled(this, 'indent');
        },
        
        indent: function() {
        	methods._executeCommand(this, 'indent');
        },
        
        isOutdentPossible: function() {
        	return methods._queryCommandEnabled(this, 'outdent');
        },
        
        outdent: function() {
        	methods._executeCommand(this, 'outdent');
        },

        isCopyPossible: function() {
        	return methods._queryCommandEnabled(this, 'copy');
        },
        
        copy: function() {
        	methods._executeCommand(this, 'copy');
        },
        
        isCutPossible: function() {
        	return methods._queryCommandEnabled(this, 'cut');
        },
        
        cut: function() {
        	methods._executeCommand(this, 'cut');
        },
        
        isRemovePossible: function() {
        	return methods._queryCommandEnabled(this, 'delete');
        },
        
        remove: function() {
        	methods._executeCommand(this, 'delete');
        },
        
        isPastePossible: function() {
        	return methods._queryCommandEnabled(this, 'paste');
        },
        
        paste: function() {
        	methods._executeCommand(this, 'paste');
        },

        isBackColorPossible: function() {
        	return methods._queryCommandEnabled(this, 'backColor');
        },
        
        backColor: function(color) {
        	methods._executeCommand(this, 'backColor', false, color);
        },

        isFontNamePossible: function() {
        	return methods._queryCommandEnabled(this, 'fontName');
        },
        
        fontName: function(name) {
        	methods._executeCommand(this, 'fontName', false, name);
        },

        isFontSizePossible: function() {
        	return methods._queryCommandEnabled(this, 'fontSize');
        },
        
        fontSize: function(size) {
        	methods._executeCommand(this, 'fontSize', false, size);
        },

        isForeColorPossible: function() {
        	return methods._queryCommandEnabled(this, 'foreColor');
        },
        
        foreColor: function(color) {
        	methods._executeCommand(this, 'foreColor', false, color);
        },

        _queryCommandEnabled: function(el, command) {
            return methods._getOwnerDocument(el).queryCommandEnabled(command);
        },

        _executeCommand: function(el, command, showDefaultUI, value) {
            methods._getOwnerDocument(el).execCommand(command, showDefaultUI, value);
            methods._triggerStateChanged(el);
        },
        
        _getOwnerDocument: function(el) {
            return el.get(0).ownerDocument;
        },

        _removePasteMarker: function(event) {
            var node = event.target;
            var tagname = node.tagName.toLowerCase();

            var marker = $('div.paste-marker', this);
            var settings = $(this).data('settings');
            
            if (marker.length > 0) {
            	methods._setSelectionAfter(this, marker.get(0));
                marker.trigger('pasted');
                
                if (settings.clearPaste) {
                	var parent = marker.parent();
                	
                	if (parent.get(0) === $(this).get(0)) {
                		parent = marker;
                	} else {
                		marker.replaceWith(marker.html());
                	}
                	
                	var content = $.htmlClean(parent.html(), {
                    	format: true
                    });
                	
                	parent.replaceWith(content);
                } else {
                	marker.replaceWith(marker.html());
                }
            }
            
            if (tagname == 'img') {
            	methods.selectNode(this, node);
            }
            
            methods._triggerStateChanged(this);
        },
        
        _correctParagraph: function(event) {
			if (event.which == 13 && !event.shiftKey) {
				var container = methods.container();
				
				if (container.length > 0) {
					var name = container.get(0).nodeName.toLowerCase();
					if (name == 'div') {
						var corrected = $('<p/>').append(container.html());

						var node = this;
		        		if (container.get(0) === node) {
		        			container.empty().append(corrected);
		        		} else {
		        			container.replaceWith(corrected);
		        		}
		        				
						methods._setSelectionAfter(this, corrected.get(0));
					} else if (name == 'p') {
						container.removeAttr('class style');
					}
				}
			}
        },
        
        _correctLists: function(el) {
        	var settings = $(el).data('settings');
        	
        	if (settings.correctLists) {
        		var container = methods.container();
        		
        		if (container.parent().get(0).nodeName.toLowerCase() == 'p') {
        			container.unwrap();
        		}
        	}
        },

        _stripHTML: function(html, ex) {
            if (!html || !html.length) {
            	return html;
            }
            
            var exclude = ex;
            function f(a, b, c){
                if (typeof exclude != 'undefined'){
                    for (var i = 0; i < exclude.length; i++){
                        if (b == exclude[i] || b == '/' + exclude[i]) {
                        	return a;
                        }
                    }
                }
                
                return '';
            }
            
            return html.replace(/<[\/]?([^> ]+)[^>]*>/g, f);
        },

        _overwriteWithNode: function(node) {
            if (window.getSelection) {
                methods._w3_overwriteWithNode(node);
            } else {
                methods._ie_overwriteWithNode(node);
            }
        },

        _ie_overwriteWithNode: function(node) {
            var rng = window.document.selection.createRange();
            var marker = methods._writeMarkerNode(window, rng);
            
            marker.appendChild(node);
            marker.removeNode(); // removes node but not children
        },

        _writeMarkerNode: function(editWindow, rng) {
            var id = editWindow.document.uniqueID;
            var html = '<span id="' + id + '"></span>';
            
            rng.pasteHTML(html);
            var node = editWindow.document.getElementById(id);
            
            return node;
        },

        _w3_overwriteWithNode: function(node) {
            var rng = window.getSelection().getRangeAt(0);
            
            rng.deleteContents();
            rng.insertNode(node);
            rng.setStartAfter(node);
            
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(rng);
        },

        _getSelectionAncestorContainer: function() {
        	var range = this._getSelectionRange();
        	
            if (range != null && range.commonAncestorContainer) {
                return range.commonAncestorContainer;
            } else if (range != null && range.parentElement) {
                return range.parentElement();
            } else {
                // Range null or ancestor container not supported
                return null;
            }
        },

        _getSelectionRange: function() {
            var range;
            
            if (window.getSelection) {
            	var selection = window.getSelection();
            	if (selection.rangeCount == 0) {
            		return null;
            	}
            	
                range = selection.getRangeAt(0);
                
                if ($.browser.opera) {
                    var s = range.startContainer;
                    
                    if(s.nodeType === Node.TEXT_NODE) {
                        range.setStartBefore(s.parentNode);
                    }
                }
            } else {
                range = window.document.selection.createRange();
                range.select(); //Restore selection, if IE lost focus.
            }

            return range;
        },
        
        _setSelection: function(node) {
        	if (window.getSelection) {
        		var range = document.createRange();
        		range.selectNode(node);
        		
        		window.getSelection().removeAllRanges();
        		window.getSelection().addRange(range);
        	}
        },

        _setSelectionContent: function(node) {
        	if (window.getSelection) {
        		var range = document.createRange();
        		range.selectNodeContents(node);
        		
        		window.getSelection().removeAllRanges();
        		window.getSelection().addRange(range);
        	}
        },
        
        _setSelectionAfter: function(el, node) {
        	if (window.getSelection) {
        		var range = document.createRange();
        		range.setStartAfter(node.lastChild);
        		range.setEndAfter(node.lastChild);
        		
        		window.getSelection().removeAllRanges();
        		window.getSelection().addRange(range);
            	
        		methods._saveRange(el);
        		methods._triggerStateChanged(el);
        	}
        },
        
        _setSelectionBefore: function(el, node) {
        	if (window.getSelection) {
        		var range = document.createRange();
        		
        		if (node.hasChildNodes()) {
        			range.setStartBefore(node.firstChild);
        			range.setEndBefore(node.firstChild);
        		} else {
        			var child = document.createElement("br");
        			node.appendChild(child);

        			range.setStartBefore(child);
        			range.setEndBefore(child);
        		}
        		
        		window.getSelection().removeAllRanges();
        		window.getSelection().addRange(range);
        	
        		methods._saveRange(el);
        		methods._triggerStateChanged(el);
        	}
        },
        
        _saveRange: function(el) {
    		var range = methods._getSelectionRange();
			var settings = $(el).data('settings');
			
			if (range.cloneRange) {
				settings.savedRange = range.cloneRange();
			} else if (range.duplicate) {
				settings.savedRange = range.duplicate();
			}
        },
        
        _focus: function(el) {
        	methods.saveSelection(el);
        },
        
        _triggerStateChanged: function(el) {
        	if (el) {
        		$(el).trigger('stateChanged');
        		methods.saveSelection(el);
        	}
        }
    };

    $.fn.editor = function(method) {
        if ( methods[method] ) {
            return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if ( typeof method === 'object' || ! method ) {
            return methods.init.apply( this, arguments );
        } else {
            $.error( 'Method ' +  method + ' does not exist on jQuery.editor' );
        }    
    };
}) (jQuery);
});
